import React, { Component } from 'react';
import homedata from '../../data/homedata.json';

class Heroarea extends Component {
  render() {
    // Use props if provided, otherwise fall back to homedata
    const data = this.props.data || homedata.heroarea;
    const isHomePage = this.props.isHomePage || false;
    const textColorClass = isHomePage ? 'text-white' : '';

    return (
      <section className="hero-area circle-wrap">
         <div className="circle x1"></div>
         <div className="circle x2"></div>
         <div className="circle x3"></div>
         <div className="circle x4"></div>
         <div className="circle x5"></div>
         <div className="circle x6"></div>
         <div className="circle x7"></div>
         <div className="circle x8"></div>
         <div className="circle x9"></div>
         <div className="circle x10"></div>
         <div className="container">
            <div className="row full-height align-items-center">
               <div className="col-lg-6 col-md-12 p-100px-t p-50px-b md-p-10px-b">
                  <h2 className={`text-capitalize m-25px-b ${textColorClass}`}>{data.title}</h2>
                  <p className={`m-25px-b ${textColorClass}`}>{data.content}</p>
                  <div className="hero-btn-wrapper">
                     <a href={data.btn1url} className="btn btn-default animated-btn">{data.btn1label}</a>
                     <a className="btn btn-default btn-default-outline animated-btn" href={data.btn2url}>{data.btn2label}</a>
                  </div>
               </div>
               <div className="col-lg-6 col-md-12 p-100px-t p-50px-b md-p-10px-t">
                  <img
                    className="hero-mock hero-mock-large"
                    src={isHomePage ? process.env.PUBLIC_URL + "/assets/img/hero-home.png" : process.env.PUBLIC_URL + (data.imgurl1 || data.imgurl)}
                    alt="Hero mockup"
                    style={isHomePage ? {maxWidth: '150%', width: '150%', marginLeft: '-25%', marginTop: '-10%'} : {}}/>
               </div>
            </div>
         </div>
      </section>
    );
  }
}

export default Heroarea;
